// extracted by mini-css-extract-plugin
module.exports = {"fxRate":"exchange-rate-panel_fxRate__j8_ED"};